<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:00em; padding-top:15px;">This endeavour could never have been accomplished without the courage and generosity of those people who have valiantly shared their stories for the greater good. I am hugely indebted to them all for the additional sacrifices they have made in offering their personal testimonies for this book.</p>
<p style="text-indent:00em; padding-top:15px;">Particular thanks are due to Dr Jane Quinn, Dr Remington Nevin and Bea Coldwell for reviewing the text and providing much-valued advice and encouragement throughout. And I must also express my gratitude to Dr Ashley Croft, Trixie Foster and David Rimmington for all their work in this field.</p>
<p style="text-indent:00em; padding-top:15px;">Above all, I have to acknowledge the support of family and friends who have come to understand the nature of Lariam injuries. Their patience and kind tolerance over many years has been inspirational.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?a327c4f6